var objActivityEdit = {
    
    _initializeObjActivityEdit: function (me) {
        /// <summary>
        /// This function builds the HTML structure for the activity edit view and initializes all events
        /// </summary>

        me._cache = me._cache || {};
        me._cache.tickets = me._cache.tickets || new Map();

        me.navCooldownMs = 300;   // short timeout for navigation buttons to block double clicks
        me.navClickLock = false;  // to block double clicks

        me.dirty = false;
        me.readOnlyMode = false;

        objActivityEdit._buildHtml(me);
        objActivityEdit._initAllEvents(me);
        objActivityEdit._setHeightsWidths(me);

        objActivityEdit._getProjectDllList(me);
        objActivityEdit._getUserDllList(me);

        objActivityEdit._initTextEditor(me, true);

        if (typeof objActivityValidation !== "undefined") {
            objActivityValidation._validate(me);
        }

        objActivityEdit._updatePasteButtonState(me);

    },

    _setHeightsWidths: function (me) {
        /// <summary>
        /// This function sets the heights and widths of certain elements in the activity edit form
        /// </summary>
        try {
            // set heights of date, time and km/travel time fields to be equal
            var hDate = me.fnd("#div-date-single-wrapper").outerHeight();
            me.fnd("#div-start-time-wrapper").outerHeight(hDate);
            me.fnd("#div-end-time-wrapper").outerHeight(hDate);
            me.fnd("#div-txt-field-km").outerHeight(hDate); 
            me.fnd("#div-txt-travel-time").outerHeight(hDate);

            var hWidget = me.fnd("#div-activity-edit").height();
            var hMenu = me.fnd("#div-edit-menu").outerHeight(true);
            me.fnd("#div-edit-area").height(hWidget - hMenu - 5); // 5px for padding

            //var wTickets = me.fnd("#div-col-tickets").outerWidth();
            //me.fnd("#div-ddl-projects").outerWidth(wTickets);
            //me.fnd("#div-ticket-list").outerWidth(wTickets);
            //me.fnd("#div-filter").outerWidth(wTickets);


            var hTickets = me.fnd("#div-col-tickets").outerHeight();
            var hDdlProjects = me.fnd("#div-ddl-projects").outerHeight();
            var ticketFilter = me.fnd("#div-ticket-filter-row").outerHeight();
            var hFilter = me.fnd("#div-filter-wrapper").outerHeight();
            var noTicket = me.fnd("#div-ticket-no-ticket-row").outerHeight();
            var hTicketList = hTickets - hDdlProjects - ticketFilter - hFilter - noTicket - 100;
            me.fnd("#div-ticket-list-wrapper").height(hTicketList);
            me.fnd("#div-ticket-list").height(hTicketList - 25);
            me.fnd(".lst-entries").height(hTicketList - 25).css("max-height", hTicketList - 25).css("overflow-y", "auto"); 

            var hEditor = objActivityEdit._calcEditorHeight(me);
            me.fnd("#div-description").height(hEditor);

        } catch (e) { me._writeErr(e); }
    },

    _buildHtml: function (me) {
        /// <summary>
        /// This function builds the HTML structure for the activity edit form
        /// </summary>
        try {
            me.myHtml.activityEdit = me._setObj("div-activity-edit", "vc-grid-margin-right float vc-grid-margin-bottom").css("height", "100%").css("max-width", "1300px");

            //add top menu with navigation buttons
            me.myHtml.activityEdit.menu = me._setObj("div-edit-menu", "vc-grid-margin-right float vc-grid-margin-bottom");
            let menu = me.myHtml.activityEdit.menu;
            menu.css({
                width: me.myRoot.width(),
                display: "grid",
                "grid-template-columns": "1fr auto 1fr",
                "align-items": "center"
            });

            // back + paste button (left)
            menu.leftGroupBack = me._setWrapper("div-edit-left", "");
            menu.leftGroupBack.css({
                "justify-self": "start",
                display: "flex",
                "align-items": "center",
                gap: "8px"
            });

            menu.btnBack = me._setObj("btn-back", "button-toggle").html(me.specific.resources.back).css({ "width": "100px" }).button();

            // paste button 
            menu.btnPasteLast = me._setObj("btn-activity-paste", "button-toggle").html("<i class='fa-regular fa-clipboard' aria-hidden='true'></i>").attr("title", me.specific.resources.pasteLastActivity || "Letzte Activity einfügen").css({ "width": "40px" }).button();
            menu.btnPasteLast.button("disable"); // will be enabled if there is something to paste
            menu.leftGroupBack.append(menu.btnBack, menu.btnPasteLast);

            // navigation buttons prev/next
            menu.centerGroup = me._setWrapper("div-edit-center", "");
            menu.centerGroup.css({ "justify-self": "center", display: "flex", "align-items": "center", gap: "8px" });
            menu.btnPrev = me._setObj("btn-prev", "button-toggle").html("<i class='fa fa-chevron-left'></i>").css({ "width": "36px" }).button();
            menu.btnNext = me._setObj("btn-next", "button-toggle").html("<i class='fa fa-chevron-right'></i>").css({ "width": "36px" }).button();
            menu.centerGroup.append(menu.btnPrev, menu.btnNext);

            // save area
            menu.saveWrapper = me._setWrapper("div-state", "clear");
            menu.saveWrapper.css({ "justify-self": "end" });
            menu.stateInfo = me._setObj("div-errors", "state-info").hide(); // error message
            menu.btnSave = me._setObj("div-btn-save", "button-toggle").html(me.specific.resources.save).css({ "width": "100px" }).button();
            menu.saveWrapper.append(menu.stateInfo, menu.btnSave);

            menu.append(menu.leftGroupBack, menu.centerGroup, menu.saveWrapper);

            menu.btnPrev.button("disable");
            menu.btnNext.button("disable");

            // add edit area where activity details can be edited
            me.myHtml.activityEdit.editArea = {};
            let editArea = me.myHtml.activityEdit.editArea;
            editArea.wrapper = me._setObj("div-edit-area", "")/*.height(600)*/.css({ display: "flex", gap: "20px" });

            //------------------------- field 1 area with project and ticket selection
            editArea.ticketBox = {};
            let ticket = editArea.ticketBox;

            ticket.wrapper = me._setFieldset("div-col-tickets", "field1 vc-grid-margin-bottom", me.specific.resources.tickets);
            ticket.options = me._setObj("", "float-box");

            ticket.divProjects = me._setWrapper("div-ddl-projects", "formItem formItemValid type-select");
            ticket.captionProjects = me._setObj("", "caption").html(me.specific.resources.project);
            ticket.ddlProjects = me._setObj("ddl-projects", "value edit").attr("placeholder", "Bitte auswählen");
            ticket.txtProjects = me._setObj("txt-projects", "value large readonly is-ddl");
            ticket.divProjects.append(ticket.captionProjects, ticket.ddlProjects, ticket.txtProjects);
            ticket.options.append(ticket.divProjects);

            // add ticket filter options            
            ticket.divFilterRow = me._setObj("div-ticket-filter-row", "vc-grid-margin-bottom").css({ display: "flex", alignItems: "center", gap: "20px", padding: "5px 0 5px 0" });

            ticket.divAllOpen = $("<div>").css({ display: "flex", gap: "5px", alignItems: "center" });
            ticket.chbAllOpen = $("<input>").attr({ type: "checkbox", id: "chb-all-open-tickets", value: "allOpen" }).data("filterId", 0);
            ticket.lblAllOpen = $("<label>").attr("for", "chb-all-open-tickets").text(me.specific.resources.allOpen);
            ticket.divAllOpen.append(ticket.chbAllOpen, ticket.lblAllOpen);

            ticket.divMyOpen = $("<div>").css({ display: "flex", gap: "5px", alignItems: "center" });
            ticket.chbMyOpen = $("<input>").attr({ type: "checkbox", id: "chb-my-tickets", value: "myOpen" }).data("filterId", 1);
            ticket.lblMyOpen = $("<label>").attr("for", "chb-my-tickets").text(me.specific.resources.myOpen);
            ticket.divMyOpen.append(ticket.chbMyOpen, ticket.lblMyOpen);

            ticket.divAll = $("<div>").css({ display: "flex", gap: "5px", alignItems: "center" });
            ticket.chbAll = $("<input>").attr({ type: "checkbox", id: "chb-all-tickets", value: "all" }).data("filterId", 2);
            ticket.lblAll = $("<label>").attr("for", "chb-all-tickets").text(me.specific.resources.all);
            ticket.divAll.append(ticket.chbAll, ticket.lblAll);

            ticket.divFilterRow.append(ticket.divAllOpen, ticket.divMyOpen, ticket.divAll);
            ticket.options.append(ticket.divFilterRow);


            // add div-filter
            ticket.divFilterWrapper = $("<div>").attr("id", "div-filter-wrapper").css("display", "flex");
            ticket.divFilter = $("<div>").attr("id", "div-filter").addClass("vc-filter vc-grid-margin-bottom").css("width", "100%");
            ticket.divFilterWrapper.append(ticket.divFilter);
            ticket.options.append(ticket.divFilterWrapper);

            // separation line
            ticket.options.append($("<hr>").css({ width: "100%", border: "none", borderTop: "1px solid #ccc", "margin-top": "2px" }));

            ticket.divNoTicketRow = me._setObj("div-ticket-no-ticket-row", "").css({ display: "flex", alignItems: "center"});

            ticket.divNone = $("<div>").css({ display: "flex", gap: "10px", alignItems: "center" });
            ticket.chbNone = $("<input>").attr({ type: "checkbox", id: "chb-no-ticket", value: "none" }).data("filterId", -1);
            ticket.lblNone = $("<label>").attr("for", "chb-no-ticket").text(me.specific.resources.noTicket);
            ticket.divNone.append(ticket.chbNone, ticket.lblNone);

            ticket.divNoTicketRow.append(ticket.divNone);
            if (!me.specific.mandatoryTicketActivity)
                ticket.options.append(ticket.divNoTicketRow);



            // add ticket list
            ticket.divTicketListWrapper = me._setWrapper("div-ticket-list-wrapper", "vc-grid-margin-bottom"); //.css("height", "400px");

            ticket.captionTicketList = me._setObj("", "caption"); //.html("Ticketliste");
            ticket.divTicketList = me._setObj("div-ticket-list", "vc-list ticket-list").css({ "display": "none", "border": "1px solid transparent", "padding": "2px", "box-sizing": "border-box" });

            ticket.divTicketListWrapper.append(ticket.captionTicketList, ticket.divTicketList);
            ticket.options.append(ticket.divTicketListWrapper);
            ticket.wrapper.append(ticket.options);


            //------------------------------- field 2 area with info/status information and description box
            editArea.middleArea = {};
            editArea.middleArea.wrapper = me._setFieldset("div-middle-area", "field2", "").css({ "width": "73%", "display": "flex", "flex-direction": "column" });

            editArea.middleArea.infoBox = {};
            let obj = editArea.middleArea.infoBox;
            obj.wrapper = me._setWrapper("div-col-info", "").css("overflow", "visible").removeClass("vc-grid-margin-bottom");

            // 2 columns within info box
            obj.grid = $("<div>").addClass("info-grid").css({ display: "grid", gridTemplateColumns: "60% 40%", gap: "10px", alignItems: "start" });

            obj.leftCol = $("<div>").addClass("info-left");
            obj.rightCol = $("<div>").addClass("info-right");

            //add left options
            obj.options = me._setObj("", "float-box ");

            //add project info
            obj.divInfoProject = me._setWrapper("div-info-project", "").css({ "width": "100%", "height": "18px", "display": "flex", "align-items": "center", "gap": "8px" });
            obj.imgInfoProject = $("<i>").addClass("fa fa-globe"); 
            obj.infoProject = me._setObj("txt-info-project", "value large readonly");
            obj.divInfoProject.append(obj.imgInfoProject, obj.infoProject);

            obj.divInfoTicket = me._setWrapper("div-info-tickets", "").css({ "width": "100%", "height": "18px", "display": "flex", "align-items": "center", "gap": "8px" });
            obj.imgInfoTicket = $("<i>").addClass("fa-regular fa-ticket");
            obj.txtTickets = me._setObj("txt-tickets", "value large readonly");
            obj.divInfoTicket.append(obj.imgInfoTicket, obj.txtTickets);

            obj.options.append(obj.divInfoProject, obj.divInfoTicket);

            // add wrapper for date, start time and end time
            obj.divDateStartWrapper = me._setObj("", "flex-row").css({ "display": "flex", "gap": "10px", "align-items": "flex-start" });

            // date box
            obj.divDateSingle = me._setWrapper("div-date-single-wrapper", "formItem formItemValid type-date").css({ "width": "200px", "overflow": "visible" }).removeClass("vc-grid-margin-bottom");
            obj.captionDateSingle = me._setObj("", "caption").html(me.specific.resources.date);
            obj.dateBoxSingle = $("<div>").attr("id", "div-date-single");
            obj.divDateSingle.append(obj.captionDateSingle, obj.dateBoxSingle);

            // text box for start time
            obj.divStartTime = me._setWrapper("div-start-time-wrapper", "formItem formItemValid type-text").css({ "width": "75px" }).removeClass("vc-grid-margin-bottom");
            obj.captionStartTime = me._setObj("", "caption").html(me.specific.resources.from);
            obj.txtStartTime = me._setInput("txt-start-time", "value large").css("width", "55px");
            obj.divStartTime.append(obj.captionStartTime, obj.txtStartTime);

            // text box for end time
            obj.divEndTime = me._setWrapper("div-end-time-wrapper", "formItem formItemValid type-text").css({ "width": "75px" }).removeClass("vc-grid-margin-bottom");
            obj.captionEndTime = me._setObj("", "caption").html(me.specific.resources.to);
            obj.txtEndTime = me._setInput("txt-end-time", "value large").css("width", "55px");
            obj.divEndTime.append(obj.captionEndTime, obj.txtEndTime);

            // append date, start time and end time to the wrapper
            obj.divDateStartWrapper.append(obj.divDateSingle, obj.divStartTime, obj.divEndTime);
            obj.options.append(obj.divDateStartWrapper);

            // add user dropdown
            obj.divUsers = me._setWrapper("div-ddl-users", "formItem formItemValid type-select"); //.css("width", "440px");
            obj.captionUsers = me._setObj("", "caption").html(me.specific.resources.user);
            obj.ddlUsers = me._setObj("ddl-users", "value edit").attr("placeholder", "Bitte auswählen");
            obj.txtUsers = me._setObj("txt-users", "value large readonly is-ddl");
            obj.divUsers.append(obj.captionUsers, obj.ddlUsers, obj.txtUsers);
            //obj.options.append(obj.divUsers);

            obj.leftCol.append(obj.options);

            // ------ end of left column, start right column

            editArea.middleArea.statusBox = {};
            var status = editArea.middleArea.statusBox;

            status.wrapper = $("<div>").attr("id", "div-col-status").addClass("status-in-info").css({ display: "flex", flexDirection: "column", gap: "10px" });

            // add different checkboxes and textboxes for status
            status.divStatusRow = $("<div>").css({ display: "flex", alignItems: "center", gap: "10px", padding: "5px 0 5px 0", flexWrap: "wrap" });

            // checkbox containers
            status.divUnread = $("<div>").css({ display: "flex", gap: "5px", alignItems: "center" });
            status.chbUnread = $("<input>").attr({ type: "checkbox", id: "chb-is-unread", value: "none" });
            status.lblUnread = $("<label>").attr("for", "chb-is-unread").text(me.specific.resources.unread);
            status.divUnread.append(status.chbUnread, status.lblUnread);

            status.divPublic = $("<div>").css({ display: "flex", gap: "5px", alignItems: "center" });
            status.chbPublic = $("<input>").attr({ type: "checkbox", id: "chb-is-public", value: "none" });
            status.lblPublic = $("<label>").attr("for", "chb-is-public").text(me.specific.resources.public);
            status.divPublic.append(status.chbPublic, status.lblPublic);

            status.divDone = $("<div>").css({ display: "flex", gap: "5px", alignItems: "center" });
            status.chbDone = $("<input>").attr({ type: "checkbox", id: "chb-is-done", value: "none" });
            status.lblDone = $("<label>").attr("for", "chb-is-done").text(me.specific.resources.done);
            status.divDone.append(status.chbDone, status.lblDone);

            status.divCleared = $("<div>").css({ display: "flex", gap: "5px", alignItems: "center" });
            status.chbCleared = $("<input>").attr({ type: "checkbox", id: "chb-is-cleared", value: "none" });
            status.lblCleared = $("<label>").attr("for", "chb-is-cleared").text(me.specific.resources.activityAccounted);
            status.divCleared.append(status.chbCleared, status.lblCleared);

            // append to the status row
            status.divStatusRow.append(
                status.divUnread,
                status.divPublic,
                status.divDone,
                status.divCleared
            );

            status.divStatusRow.children("div").css({ flex: "0 0 calc(50% - 10px)" });
            status.wrapper.append(status.divStatusRow);

            status.divKmAndTravelTime = $("<div>").css({ display: "flex", gap: "10px", "align-items": "flex-start" });
            status.divTxtKm = me._setWrapper("div-txt-field-km", "formItem formItemValid type-text").css({ "width": "120px" }).removeClass("vc-grid-margin-bottom");
            status.captionTxtKm = me._setObj("", "caption").html("km");
            status.txtKm = me._setInput("txt-km", "value large").css("width", "100px").val("0");
            status.divTxtKm.append(status.captionTxtKm, status.txtKm);
            status.divKmAndTravelTime.append(status.divTxtKm);

            status.divTxtTravelTime = me._setWrapper("div-txt-travel-time", "formItem formItemValid type-text").css({ "width": "120px" }).removeClass("vc-grid-margin-bottom");
            status.captionTxtTravelTime = me._setObj("", "caption").html(me.specific.resources.travel + " (h)");
            status.txtTravelTime = me._setInput("txt-travel-time", "value large").css("width", "100px").val("0");
            status.divTxtTravelTime.append(status.captionTxtTravelTime, status.txtTravelTime);
            status.divKmAndTravelTime.append(status.divTxtTravelTime);
            status.wrapper.append(status.divKmAndTravelTime);
            obj.rightCol.append(status.wrapper);

            obj.grid.append(obj.leftCol, obj.rightCol);
            obj.wrapper.append(obj.grid);

            editArea.middleArea.wrapper.append(obj.wrapper); 

            // add description box
            editArea.descBox = {};
            let desc = editArea.descBox;
            desc.wrapper = me._setObj("div-col-description", ""); 

            // container for description text area
            desc.divEditor = me._setObj("div-editor", "formItem formItemValid type-text");

            // description text area
            desc.captionRow = me._setObj("div-desc-caption-row", "caption-row");
            desc.captionDescription = me._setObj("", "caption").html(me.specific.resources.description);
            desc.captionRow.append(desc.captionDescription);


            desc.divDescription = me._setObj("div-description", "value readonly");
            desc.txtDescription = me._setTextArea("area-description", "value");
            desc.divEditor.append(desc.captionRow, desc.divDescription, desc.txtDescription);

            desc.wrapper.append(desc.divEditor);
            editArea.middleArea.wrapper.append(desc.wrapper);
            editArea.wrapper.append(ticket.wrapper, editArea.middleArea.wrapper); 

            me.myHtml.activityEdit.append(menu, editArea.wrapper);
            me.myHtml.content.append(me.myHtml.activityEdit);

        } catch (e) { me._writeErr(e); }
    },


    _initAllEvents: function (me) {
        /// <summary>
        /// This function initializes all events for the activity day view
        /// </summary>

        try {

            me.myHtml.activityEdit.editArea.middleArea.infoBox.dateBoxSingle.vcDate({
                mode: "Single",
                align: "right",
                interval: 1,
                langID: me.settings.userLangIDForCulture || me.specific.userLangID,
                callback: function (obj) {
                    me.myStatus.selectedDate = obj.singleDate;
                    me.dirty = true;
                }
            });


            objActivityEdit._initTimeEventsAndValidation(me);

            me.myHtml.activityEdit.menu.btnBack.off("click").on("click", function () {
                if (!me.dirty || !me.myStatus.editMode) {
                    me.dirty = false;

                    me.myHtml.activityEdit.hide();
                    if (me.myStatus.selectedMode === "dayview") {
                        objActivityDayView._generateDayview(me);
                        me.myHtml.activityDayview.show();
                    } else {
                        objActivityList._generateList(me);
                        me.myHtml.activityList.show();
                    }
                    return;
                }

                me.openAskDialog(
                    me.specific.resources.wantToSaveChanges,
                    { my: 'center', at: 'center', of: window },
                    function onYes() {

                        // we check if end time is after start time
                        if (typeof objActivityValidation !== "undefined") {
                            var badTime = !objActivityValidation._validateTimeRelation(me);
                            if (badTime) {
                                objActivityEdit._setStateError(me, "* " + me.specific.resources.endtimeBeforeStarttime);

                                me.openInfoDialog(
                                    me.specific.resources.endtimeIsBeforeStarttime,
                                    { at: 'center center-20%', of: window }
                                );
                                return;
                            }
                        }

                        // if everything ok, save changes
                        const currEdited = objActivityEdit._getCurrentFullSelection(me);
                        objActivityEdit._updateActiveRow(me, currEdited);
                        objActivityEdit._saveActivity(me);

                        me.dirty = false;

                        me.myHtml.activityEdit.hide();
                        if (me.myStatus.selectedMode === "dayview") {
                            objActivityDayView._generateDayview(me);
                            me.myHtml.activityDayview.show();
                        } else {
                            objActivityList._generateList(me);
                            me.myHtml.activityList.show();
                        }
                    },

                    // NO - no save
                    function onNo() {
                        me.dirty = false;

                        me.myHtml.activityEdit.hide();
                        if (me.myStatus.selectedMode === "dayview") {
                            objActivityDayView._generateDayview(me);
                            me.myHtml.activityDayview.show();
                        } else {
                            objActivityList._generateList(me);
                            me.myHtml.activityList.show();
                        }
                        return true;
                    }
                );
            });

            me.myHtml.activityEdit.menu.btnSave.on("click", function () {
                // save current changes for navigation
                const currEdited = objActivityEdit._getCurrentFullSelection(me);
                objActivityEdit._updateActiveRow(me, currEdited);

                objActivityEdit._saveActivity(me);
                me.dirty = false;
            });

            me.fnd("#chb-all-open-tickets, #chb-my-tickets, #chb-all-tickets").on("change", function (e) {
                const chbNone = me.fnd("#chb-no-ticket");
                const divList = me.myHtml.activityEdit.editArea.ticketBox.divTicketList;

                const obj = $(this);
                const checked = obj.is(":checked");

                if (checked) {
                    me.fnd("#chb-all-open-tickets, #chb-my-tickets, #chb-all-tickets").not(this).prop("checked", false);
                    chbNone.prop("checked", false);
                    divList.removeClass("disabled");
                } else {
                    setTimeout(function () { objActivityEdit._ensureOneTicketFilterSelected(me); }, 0);
                    return;
                }

                me.myStatus.filterId = parseInt(obj.data("filterId"), 10);
                if (isNaN(me.myStatus.filterId)) me.myStatus.filterId = -1;

                if (me.ddlProjects) me.ddlProjects.enable();

                const bdid = me.ddlProjects ? me.ddlProjects.getValue() : -1;
                objActivityEdit._getTicketDllListCached(me, true, bdid, function () {
                    me.selectedTicketId = null;
                    me.myHtml.activityEdit.editArea.middleArea.infoBox.txtTickets.html("");
                });

                divList.removeClass("disabled");
                me.dirty = true;
            });

            me.fnd("#chb-no-ticket").on("change", function () {
                const chbNone = me.fnd("#chb-no-ticket");
                const divList = me.myHtml.activityEdit.editArea.ticketBox.divTicketList;

                if (chbNone.is(":checked")) {
                    me.fnd("#chb-all-open-tickets, #chb-my-tickets, #chb-all-tickets").prop("checked", false);

                    divList.addClass("disabled");
                    me.selectedTicketId = null;
                    me.myHtml.activityEdit.editArea.middleArea.infoBox.txtTickets.html("");
                    divList.find(".vc-list-item").removeClass("selected");

                    me.myStatus.filterId = -1;
                } else {
                    objActivityEdit._ensureOneTicketFilterSelected(me);
                }

                if (typeof objActivityValidation !== "undefined") {
                    objActivityEdit._clearSaveState(me);
                    objActivityValidation._validateTicket(me);
                    objActivityValidation._updateSaveButtonStatus(me, false);
                }

                me.dirty = true;
            });


            me.fnd("#div-filter").vcFilter({
                setWidth: me.fnd("#div-filter").width(),
                callback: function () {
                    objActivityEdit._onTicketFilterChanged(me);
                }
            });

            me.myHtml.activityEdit.editArea.middleArea.statusBox.txtKm.on("change input", function () {
                me.dirty = true;
                objActivityEdit._clearSaveState(me);
                objActivityValidation._validateNumberTextbox(me, "#div-txt-field-km", me.myHtml.activityEdit.editArea.middleArea.statusBox.txtKm);
                objActivityValidation._updateSaveButtonStatus(me, false);
            });

            me.myHtml.activityEdit.editArea.middleArea.statusBox.txtTravelTime.on("change input", function () {
                me.dirty = true;
                objActivityEdit._clearSaveState(me);
                objActivityValidation._validateNumberTextbox(me, "#div-txt-travel-time", me.myHtml.activityEdit.editArea.middleArea.statusBox.txtTravelTime);
                objActivityValidation._updateSaveButtonStatus(me, false);
            });

            me.myHtml.activityEdit.menu.btnPrev.off("click").on("click", function () {
                // we block fast clicks, otherwise we have problems to load the correct entry
                if (me.navClickLock) return;
                me.navClickLock = true;
                setTimeout(() => { me.navClickLock = false; }, me.navCooldownMs);

                if (!me.dirty) {
                    me.dirty = false;
                    objActivityEdit._navigateThroughEntries(me, -1);
                    return;
                }

                me.openAskDialog(
                    me.specific.resources.wantToSaveChanges,
                    { my: 'center', at: 'center', of: window },

                    // YES – save changes
                    function onYes() {
                        if (typeof objActivityValidation !== "undefined") {
                            var badTime = !objActivityValidation._validateTimeRelation(me);
                            if (badTime) {
                                objActivityEdit._setStateError(me, "* " + me.specific.resources.endtimeBeforeStarttime);
                                me.openInfoDialog(
                                    me.specific.resources.endtimeIsBeforeStarttime,
                                    { at: 'center center-20%', of: window }
                                );
                                return;
                            }
                        }

                        const currEdited = objActivityEdit._getCurrentFullSelection(me);
                        objActivityEdit._updateActiveRow(me, currEdited);
                        objActivityEdit._saveActivity(me);

                        me.dirty = false;
                        objActivityEdit._navigateThroughEntries(me, -1);
                    },

                    // NO – nothing is done
                    function onNo() {
                        me.dirty = false;
                        objActivityEdit._navigateThroughEntries(me, -1);
                        return true;
                    }
                );
            });

            me.myHtml.activityEdit.menu.btnNext.off("click").on("click", function () {
                // we block fast clicks, otherwise we have problems to load the correct entry
                if (me.navClickLock) return;
                me.navClickLock = true;
                setTimeout(() => { me.navClickLock = false; }, me.navCooldownMs);

                if (!me.dirty) {
                    me.dirty = false;
                    objActivityEdit._navigateThroughEntries(me, +1);
                    return;
                }

                me.openAskDialog(
                    me.specific.resources.wantToSaveChanges,
                    { my: 'center', at: 'center', of: window },

                    // YES – save changes
                    function onYes() {

                        // we check if end time is after start time
                        if (typeof objActivityValidation !== "undefined") {
                            var badTime = !objActivityValidation._validateTimeRelation(me);
                            if (badTime) {
                                objActivityEdit._setStateError(me, "* " + me.specific.resources.endtimeBeforeStarttime);
                                me.openInfoDialog(
                                    me.specific.resources.endtimeIsBeforeStarttime,
                                    { at: 'center center-20%', of: window }
                                );
                                return;
                            }
                        }

                        const currEdited = objActivityEdit._getCurrentFullSelection(me);
                        objActivityEdit._updateActiveRow(me, currEdited);
                        objActivityEdit._saveActivity(me);

                        me.dirty = false;
                        objActivityEdit._navigateThroughEntries(me, +1);
                    },

                    // NO – do nothing
                    function onNo() {
                        me.dirty = false;
                        objActivityEdit._navigateThroughEntries(me, +1);
                        return true;
                    }
                );

            });


            var status = me.myHtml.activityEdit.editArea.middleArea.statusBox;
            status.chbPublic.on("change", function () {
                me.dirty = true;
                objActivityEdit._clearSaveState(me);
                if (typeof objActivityValidation !== "undefined") {
                    objActivityValidation._updateSaveButtonStatus(me, false);
                }
            });

            status.chbCleared.on("change", function () {
                me.dirty = true;
                objActivityEdit._clearSaveState(me);
                if (typeof objActivityValidation !== "undefined") {
                    objActivityValidation._updateSaveButtonStatus(me, false);
                }
            });

            status.chbDone.on("change", function () {
                me.dirty = true;
                objActivityEdit._clearSaveState(me);
                if (typeof objActivityValidation !== "undefined") {
                    objActivityValidation._updateSaveButtonStatus(me, false);
                }
            });


            me.myHtml.activityEdit.editArea.middleArea.statusBox.chbUnread.on("change", function () {
                me.dirty = true;
                objActivityEdit._clearSaveState(me);
                if (typeof objActivityValidation !== "undefined") {
                    objActivityValidation._updateSaveButtonStatus(me, false);
                }
            });


            // paste the whole content of last activity by clicking the paste button (expect from date/time info)
            if (me.myHtml.activityEdit.menu.btnPasteLast) {
                const menu = me.myHtml.activityEdit.menu;

                menu.btnPasteLast.off("click").on("click", function (e) {
                    e.preventDefault();

                    me.myStatus.shared = me.myStatus.shared || {};
                    const shared = me.myStatus.shared;
                    const last = shared.lastActivity;                    

                    // if nothing to paste, return
                    if (!last) return;

                    // get current date/time info (from dayview or list)
                    const curr = objActivityEdit._getCurrentFullSelection(me);
                    const info = me.myHtml.activityEdit.editArea.middleArea;

                    const lastTicketId = (last.atid != null ? last.atid : -1);
                    const lastBdid = (last.bdid != null ? last.bdid : -1);

                    // get the correct ticket info
                    if (lastTicketId > 0) {
                        me.myStatus.filterId = 0;
                        me.fnd("#chb-all-open-tickets").prop("checked", true);
                        me.fnd("#chb-my-tickets, #chb-all-tickets, #chb-no-ticket").prop("checked", false);
                        me.myHtml.activityEdit.editArea.ticketBox.divTicketList.removeClass("disabled");
                    } else {
                        // if no ticket, we disable the ticket list
                        me.myStatus.filterId = -1;
                        me.fnd("#chb-no-ticket").prop("checked", true);
                        me.fnd("#chb-all-open-tickets, #chb-my-tickets, #chb-all-tickets").prop("checked", false);
                        me.myHtml.activityEdit.editArea.ticketBox.divTicketList.addClass("disabled");
                    }

                    // we set the correct project from last activity
                    if (me.ddlProjects) {
                        me._suspendProjectChange = true;

                        if (lastBdid > 0) {
                            me.ddlProjects.setValue(lastBdid, true);
                            const sel = me.ddlProjects.options[lastBdid];
                            me.myHtml.activityEdit.editArea.middleArea.infoBox.infoProject.html(sel ? sel.Name : "");
                        } else {
                            me.ddlProjects.clear();
                            me.myHtml.activityEdit.editArea.middleArea.infoBox.infoProject.html("");
                        }

                        me._suspendProjectChange = false;
                    }

                    // we get the correct ticket list for the selected project
                    objActivityEdit._getTicketDllListCached(me, true, lastBdid, function () {

                        const status = {
                            // we set the status with the info from last activity, but date/time from current selection
                            date: (curr && curr.date) ? curr.date : new Date(),
                            startTime: curr ? curr.starttime : "",
                            endTime: curr ? curr.endtime : "",

                            ticketId: lastTicketId,
                            bdid: lastBdid,
                            userId: last.uid,
                            description: last.description || "",
                            isPublic: last.isPublic,
                            isDone: last.done,
                            cleared: last.cleared,
                            km: last.km,
                            arrival: last.arrival,

                            unread: info.statusBox.chbUnread.is(":checked")
                        };

                        // we set the full status now
                        objActivityEdit._setCurrentStatus(me, status);

                        // we ensure that the ticket is visible and selected
                        if (lastTicketId > 0) {
                            objActivityEdit._tryEnsureTicketVisibleAndSelect(me, lastBdid, lastTicketId);
                        }

                        me.dirty = true;

                        if (typeof objActivityValidation !== "undefined") {
                            objActivityEdit._clearSaveState(me);
                            objActivityValidation._validate(me);
                            objActivityValidation._updateSaveButtonStatus(me, false);
                        }
                    });
                });
            }

            (function initTicketFilterDefault() {
                me.myStatus.filterId = 0;
                const allOpen = me.fnd("#chb-all-open-tickets");
                if (!allOpen.is(":checked")) allOpen.prop("checked", true);
                allOpen.trigger("change");
            })();

        } catch (e) { me._writeErr(e); }
    },


    _initTimeEventsAndValidation: function (me) {

        const start = me.myHtml.activityEdit.editArea.middleArea.infoBox.txtStartTime;
        start.off(".time");

        start.on("input.time", function () {
            me.dirty = true;
            objActivityEdit._setNeutral(me.fnd("#div-start-time-wrapper"));
            objActivityEdit._clearSaveState(me);
            objActivityValidation._updateSaveButtonStatus(me, false);
        });

        start.on("keydown.time", function (e) {
            if (e.key === "Enter") {
                e.preventDefault();
                objActivityEdit._finalizeTime(me, start, "#div-start-time-wrapper"); // prüft leer/format intern
            }
        });


        start.on("paste.time", function () {
            setTimeout(function () {
                objActivityEdit._setNeutral(me.fnd("#div-start-time-wrapper"));
                objActivityEdit._clearSaveState(me);
                objActivityValidation._updateSaveButtonStatus(me, false);
            }, 0);
        });

        start.on("blur.time", function () {
            objActivityEdit._finalizeTime(me, start, "#div-start-time-wrapper");
        });


        const end = me.myHtml.activityEdit.editArea.middleArea.infoBox.txtEndTime;
        end.off(".time");

        end.on("input.time", function () {
            me.dirty = true;
            objActivityEdit._setNeutral(me.fnd("#div-end-time-wrapper"));
            objActivityEdit._clearSaveState(me);
            objActivityValidation._updateSaveButtonStatus(me, false);
        });

        end.on("keydown.time", function (e) {
            if (e.key === "Enter") {
                e.preventDefault();
                objActivityEdit._finalizeTime(me, end, "#div-end-time-wrapper");
            }
        });

        end.on("paste.time", function () {
            setTimeout(function () {
                objActivityEdit._setNeutral(me.fnd("#div-end-time-wrapper"));
                objActivityEdit._clearSaveState(me);
                objActivityValidation._updateSaveButtonStatus(me, false);
            }, 0);
        });

        end.on("blur.time", function () {
            objActivityEdit._finalizeTime(me, end, "#div-end-time-wrapper");
        });

    },

    _ensureOneTicketFilterSelected: function (me) {
        /// <summary>
        /// This function ensures that at least one ticket filter checkbox is selected
        /// </summary>
        const allOpen = me.fnd("#chb-all-open-tickets");
        const group = me.fnd("#chb-all-open-tickets, #chb-my-tickets, #chb-all-tickets");
        const none = me.fnd("#chb-no-ticket");

        if (none.is(":checked")) return;

        if (!group.is(":checked")) {
            allOpen.prop("checked", true).trigger("change");
        }
    },

    _onTicketFilterChanged: function (me) {
        /// <summary>
        /// This function is called when the ticket filter changes and updates the ticket list accordingly
        /// </summary>
        try {           

            let ticketSelector = "#div-ticket-list .vc-list-item";
            let filterSelector = "#div-filter";

            // reset search
            me.fnd(ticketSelector).removeClass("tagFound");

            // apply filtering
            me.setTagFilter(filterSelector, ticketSelector, "tagFound");

            // show/hide items
            me.fnd(ticketSelector).each(function () {
                if ($(this).hasClass("tagFound")) { $(this).show(); }
                else { $(this).hide(); }
            });

            me.fnd("#div-ticket-list .vc-list-item:visible").removeClass("alt").filter(":odd").addClass("alt");

        } catch (e) {
            me._writeErr(e);
        }
    },

    _tryEnsureTicketVisibleAndSelect: function (me, bdid, ticketId) {
        /// <summary>
        /// This function tries to ensure that a ticket is visible in the ticket list and selects it
        /// </summary>
        if (!(ticketId > 0)) return;

        const list = me.myHtml.activityEdit.editArea.ticketBox.divTicketList;
        let item = list.find(".vc-list-item").filter(function () {
            return $(this).data("ticket-id") === ticketId;
        });

        if (item.length) {
            // if ticket found, we select it
            item.trigger("click");
            return;
        }

        // if ticket is not found, we try to load all tickets of the project and select it then
        me.myStatus.filterId = 2; // all tickets - also closed ones
        const $allEntries = me.fnd("#chb-all-tickets");
        $allEntries.prop("checked", true);
        me.fnd("#chb-all-open-tickets, #chb-my-tickets, #chb-no-ticket").prop("checked", false);

        objActivityEdit._getTicketDllListCached(me, true, bdid, function () {
            const list2 = me.myHtml.activityEdit.editArea.ticketBox.divTicketList;
            let item2 = list2.find(".vc-list-item").filter(function () {
                return $(this).data("ticket-id") === ticketId;
            });

            if (item2.length) {
                item2.trigger("click");
            }
        });
    },

    _initSelectizeInDll: function (me, obj, dataTable, txtField, setDirty) {
        /// <summary>
        ///  This function generates a dropdown list using Selectize.js based on a DataTable object (with columns: id, name, ...).
        /// </summary>
        try {
            if (me.error) { return false; }

            // destroy previous selectize if exists
            if (obj[0].selectize) {
                obj[0].selectize.destroy();
                obj.html("");
            }

            let ddlItems = [];
            if (dataTable && Array.isArray(dataTable.rows)) {
                ddlItems = dataTable.rows.map(row => ({ Id: row.id, Name: row.name }));
            }

            var item = obj.selectize({
                create: false,
                maxItems: 1,
                valueField: 'Id',
                labelField: 'Name',
                searchField: 'Name',
                options: ddlItems,
                dropdownParent: 'body',
                render: {
                    option: function (item, escape) {
                        return "<div class='option'>" + escape(item.Name) + "</div>";
                    }
                },
                onFocus: function () { // if user clicks into ddl project, we clear the selection to allow typing directly
                    if (obj.attr("id") === "ddl-projects") {
                        this.prevValue = this.items.length ? this.items[0] : null;
                        // silently clear selection, without triggering onChange
                        this.clear(true);
                        this.open();
                    }
                },
                onBlur: function () { // if user leaves ddl project without selection, we restore the previous value
                    if (obj.attr("id") === "ddl-projects") {
                        if (!this.items.length && this.prevValue != null) {
                            this.setValue(this.prevValue, true);
                        }
                        this.prevValue = null;
                    }
                },
                onChange: function (value) {
                    var v = (value === "" || value == null) ? -1 : parseInt(value, 10);
                    if (isNaN(v)) v = -1;

                    if (txtField && value) {
                        let selected = item[0].selectize.options[value];
                        txtField.val(selected ? selected.Name : "");
                    }                    
                    let sourceId = obj.attr("id");

                    if (sourceId === "ddl-projects") {
                        if (me._suspendProjectChange) return;

                        let selected = value ? item[0].selectize.options[value] : "";
                        let projectName = selected ? selected.Name : "";
                        me.myHtml.activityEdit.editArea.middleArea.infoBox.infoProject.html(projectName);

                        objActivityEdit._renderTicketList(me, { rows: [] });
                        me.selectedTicketId = null;
                        me.myHtml.activityEdit.editArea.middleArea.infoBox.txtTickets.html("");

                        // if no ticket was selected before, we reset filter to "all open tickets"
                        if (me.myStatus.filterId === -1) {
                            me.myStatus.filterId = 0;
                            me.fnd("#chb-all-open-tickets").prop("checked", true);
                            me.fnd("#chb-my-tickets, #chb-all-tickets, #chb-no-ticket").prop("checked", false);
                            me.myHtml.activityEdit.editArea.ticketBox.divTicketList.removeClass("disabled");
                        }


                        objActivityEdit._getTicketDllListCached(me, true, v, function () {

                            if (typeof objActivityValidation !== "undefined") {
                                objActivityEdit._clearSaveState(me);
                                objActivityValidation._validateTicket(me);
                                objActivityValidation._updateSaveButtonStatus(me, false);
                            }

                        });
                    }

                    if (sourceId === "ddl-users") {
                        me.dirty = true;
                        if (typeof objActivityValidation !== "undefined") {
                            objActivityEdit._clearSaveState(me);
                            objActivityValidation._validateUser(me);
                            objActivityValidation._updateSaveButtonStatus(me, false);
                        }
                    }
                }
            });

            return item[0].selectize;
        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },

    _addActivityBtnNew: function (me, date) {
        /// <summary>
        // This function is called when the "new activity" button is clicked and prepares the edit form for a new activity
        /// </summary>
        try {
            objActivityEdit._resetEditForm(me);

            me.myStatus.filterId = 0;
            me.fnd("#chb-all-open-tickets").prop("checked", true);
            me.fnd("#chb-my-tickets, #chb-all-tickets, #chb-no-ticket").prop("checked", false);
            me.myHtml.activityEdit.editArea.middleArea.statusBox.chbUnread.prop("checked", true);
                        

            objActivityEdit._getTicketDllList(me, false, -1, function () {
                var now = (date != null) ? date : new Date(); // if new btn in dayview is clicked, we take the selected date
                objActivityEdit._setCurrentStatus(me, {
                    date: now,
                    startTime: '',
                    endTime: '',
                    bdid: me.flags.Bdid,
                    ticketId: me.flags.TicketId != -1 ? me.flags.TicketId : null,
                    userId: me.flags.UserId,
                    description: '',
                    isPublic: true,
                    isDone: true,
                    cleared: true,
                    km: 0,
                    arrival: 0,
                    unread: true
                });
                 
                objActivityEdit._showEditForm(me);

                objActivityEdit._disableNav(me);

                me.dirty = false;
            });  

        } catch (e) { me._writeErr(e); return false; }
    },

    _showEditForm: function (me) {
        /// <summary>
        /// This function shows the activity edit form and hides other views
        /// </summary>
        try {
            me.myHtml.activityList.hide();
            me.myHtml.activityDayview.hide();
            me.myHtml.activityEdit.show();

            if (me.specific.adminRights)
                me.myHtml.activityEdit.editArea.middleArea.infoBox.divUsers.show(); // show user selection if admin rights
            else
                me.myHtml.activityEdit.editArea.middleArea.infoBox.divUsers.hide();

            objActivityEdit._setHeightsWidths(me);

        } catch (e) { me._writeErr(e); return false; }

    },


    _showSaveOk: function (me) {
        /// <summary>
        /// This function shows a save-ok icon and disables the save button
        /// </summary>
        try {
            me.myHtml.activityEdit.menu.btnSave.button("disable");
            objActivityEdit._setStateClear(me);
        } catch (e) { me._writeErr(e); }
    },

    _clearSaveState: function (me) {
        /// <summary>
        /// This function clears the save state icon and enables the save button
        /// </summary>
        try {
            var m = me.myHtml.activityEdit.menu;
            m.stateInfo.hide().html("");
        } catch (e) { me._writeErr(e); }
    },

    _setStateError: function (me, htmlText) {
        /// <summary>
        /// This function shows an error state with the provided HTML text and disables the save button
        /// </summary>
        try {
            if (!me || !me.myHtml || !me.myHtml.activityEdit || !me.myHtml.activityEdit.menu) return;
            var menu = me.myHtml.activityEdit.menu;

            if (menu.saveWrapper) menu.saveWrapper.removeClass("clear").addClass("error").show();
            if (menu.stateInfo) menu.stateInfo.html(htmlText || "").show();

            var btn = (menu.btnSave) ? menu.btnSave : $();
            var exists = btn && btn.length && document.body.contains(btn[0]);

            if (exists) {
                var isUiBtn = !!(btn.data("uiButton") || btn.hasClass("ui-button"));
                if (isUiBtn && typeof btn.button === "function") {
                    btn.button("disable");
                } else {
                    btn.prop("disabled", true).addClass("ui-state-disabled");
                }
            }
        } catch (e) { me._writeErr(e); }
    },

    _setStateClear: function (me) {
        /// <summary>
        /// This function shows a clear state with a check icon and disables the save button
        /// </summary>
        try {
            var menu = me.myHtml.activityEdit.menu;
            menu.saveWrapper.removeClass("error").addClass("clear").show();
            menu.stateInfo.hide().html("");         
        } catch (e) { me._writeErr(e); }
    },


    _addGapActivity: function (me, date, fromTime, toTime) {
        /// <summary>
        // This function is called when the "add gap activity" button is clicked and prepares the edit form for a gap activity
        /// </summary>

        try {
            objActivityEdit._resetEditForm(me);

            me.myStatus.filterId = 0;
            me.fnd("#chb-all-open-tickets").prop("checked", true);
            me.fnd("#chb-my-tickets, #chb-all-tickets, #chb-no-ticket").prop("checked", false);
            me.myHtml.activityEdit.editArea.middleArea.statusBox.chbUnread.prop("checked", true);

            objActivityEdit._getTicketDllList(me, false, -1, function () {                
                objActivityEdit._setCurrentStatus(me, {
                    date: date.from,
                    startTime: fromTime || '',
                    endTime: toTime || '',
                    ticketId: null,
                    bdid: me.flags.Bdid,
                    userId: me.flags.UserId,
                    description: '',
                    isPublic: true,
                    isDone: true,
                    cleared: true,
                    km: 0,
                    arrival: 0,
                    unread: true
                });

                objActivityEdit._showEditForm(me); 
                objActivityEdit._disableNav(me);
            });

        } catch (e) { me._writeErr(e); return false; }
    },

    _editExistingActivity: function (me, entry, reqId) {
        /// <summary>
        // This function is called when an existing activity is to be edited and prepares the edit form with the activity data
        /// </summary>
        try {
           
            if (typeof reqId !== "number") {
                me.editReqId = (me.editReqId || 0) + 1;
                reqId = me.editReqId;
            }

            objActivityEdit._resetEditForm(me);
            
            var hasBillingDate = entry.billingdate != null && entry.billingdate != undefined; // billingdate is set for new activities            
            var hasAccounting = entry.accountingtime != null && String(entry.accountingtime).trim() !== ""; // for old activities, we need to check accountingtime of corresponding ticket            

            // restricted users (OwnActivitiesOnly) may only edit their own activities
            var isOtherUsersActivity = !!(me.flags && me.flags.OwnActivitiesOnly) && parseInt(entry.uid, 10) !== parseInt(me.flags.CurrentUserId, 10);

            me.readOnlyMode = hasBillingDate || hasAccounting || isOtherUsersActivity; // readonly if billingdate or accountingtime is set

            //if ticket ID is set, we select "all open tickets" as filter; if no ticket ID, we select "no ticket" and disable the ticket list
            if (entry.atid && entry.atid > 0) {
                me.myStatus.filterId = 0;
                me.fnd("#chb-all-open-tickets").prop("checked", true);
                me.fnd("#chb-my-tickets, #chb-all-tickets, #chb-no-ticket").prop("checked", false);
            } else {
                me.myStatus.filterId = -1;
                me.fnd("#chb-no-ticket").prop("checked", true);
                me.fnd("#chb-all-open-tickets, #chb-my-tickets, #chb-all-tickets").prop("checked", false);
                me.myHtml.activityEdit.editArea.ticketBox.divTicketList.addClass("disabled");
            }

            // set project in dropdown (GUARD to avoid onChange event)
            if (me.ddlProjects) {
                me._suspendProjectChange = true;               // guard on
                me.ddlProjects.setValue(entry.bdid, true);     // set value in project dll
                me._suspendProjectChange = false;              // guard off

                // update project name in info box
                const sel = me.ddlProjects.options[entry.bdid];
                me.myHtml.activityEdit.editArea.middleArea.infoBox.infoProject.html(sel ? sel.Name : "");
            }
            else
                me.pendingProjectId = entry.bdid;


            objActivityEdit._getTicketDllListCached(me, true, entry.bdid, function () {

                if (reqId !== me.editReqId) return;

                const status = {
                    date: entry.date,
                    startTime: entry.starttime,
                    endTime: entry.endtime,
                    ticketId: entry.atid,
                    bdid: entry.bdid,
                    userId: entry.uid,
                    description: entry.description,
                    isPublic: entry.isPublic,
                    isDone: entry.done,
                    cleared: entry.cleared,
                    km: entry.km,
                    arrival: entry.arrival,
                    unread: !entry.uid_seen
                };

                objActivityEdit._setCurrentStatus(me, status);

                me.myStatus.shared = me.myStatus.shared || {};
                me.myStatus.shared.lastActivity = {
                    date: status.date,
                    starttime: status.startTime,
                    endtime: status.endTime,
                    atid: status.ticketId,
                    bdid: status.bdid,
                    uid: status.userId,
                    description: status.description || "",
                    isPublic: status.isPublic,
                    done: status.isDone,
                    cleared: status.cleared,
                    km: status.km,
                    arrival: status.arrival
                };
                me.myStatus.shared.lastDescription = status.description || "";

                objActivityEdit._updatePasteButtonState(me);

                // ensure that ticket is visible and selected
                if (entry.atid && entry.atid > 0) {
                    objActivityEdit._tryEnsureTicketVisibleAndSelect(me, entry.bdid, entry.atid);
                }

                if (reqId !== me.editReqId) return;

                objActivityEdit._applyReadOnlyMode(me);

                objActivityEdit._showEditForm(me);
                objActivityEdit._updateNavButtons(me);

                me.dirty = false;

            });  
                       
        } catch (e) { me._writeErr(e); }
    },

    _setCurrentStatus: function (me, status) {
        /// <summary>
        /// This function sets the current status of the activity edit view based on the provided status object.
        /// </summary>
        try {            

            // update date in date box
            if (status.date) {
                me.myHtml.activityEdit.editArea.middleArea.infoBox.dateBoxSingle.vcDate("destroy");
                me.myHtml.activityEdit.editArea.middleArea.infoBox.dateBoxSingle.vcDate({
                    mode: "Single",
                    align: "right",
                    interval: 1,
                    langID: me.settings.userLangIDForCulture || me.specific.userLangID,
                    defaultDate: objActivityEdit._formatDate(status.date),
                    callback: function (obj) {
                        //me.myStatus.selectedDate = obj.singleDate;

                        me.dirty = true;
                        objActivityEdit._clearSaveState(me);
                        if (typeof objActivityValidation !== "undefined") {
                            objActivityValidation._updateSaveButtonStatus(me, false);
                        }
                    }
                });
            }

            // set start time
            if (status.startTime !== undefined) {
                me.myHtml.activityEdit.editArea.middleArea.infoBox.txtStartTime.val(status.startTime);
            }

            // set end time
            if (status.endTime !== undefined) {
                me.myHtml.activityEdit.editArea.middleArea.infoBox.txtEndTime.val(status.endTime);
            }

            // set ticket ID in dropdown, if ticket ID is not -1
            me.selectedTicketId = status.ticketId;
            me.myHtml.activityEdit.editArea.ticketBox.divTicketList.removeClass("disabled");
            if (status.ticketId > -1) {
                let listWrapper = me.myHtml.activityEdit.editArea.ticketBox.divTicketList;
                if (listWrapper) {
                    listWrapper.find(".vc-list-item").removeClass("selected");

                    let selectedTicketName = null;

                    listWrapper.find(".vc-list-item").each(function () {
                        if ($(this).data("ticket-id") === status.ticketId) {
                            $(this).addClass("selected");
                            selectedTicketName = $(this).text().trim();
                        }
                    });

                    me.myHtml.activityEdit.editArea.middleArea.infoBox.txtTickets.html(selectedTicketName || "");
                }
            }
            else { // no ticket is selected in the ticket list; if edit mode, checkbox "no ticket" is selected
                me.myHtml.activityEdit.editArea.middleArea.infoBox.txtTickets.html("");
                me.fnd("#chb-no-ticket").prop("checked", true);
                me.fnd("#chb-all-open-tickets, #chb-my-tickets, #chb-all-tickets").prop("checked", false);
                me.myHtml.activityEdit.editArea.ticketBox.divTicketList.addClass("disabled");
                me.myStatus.filterId = -1;
                me.selectedTicketId = null;
            }

            // set project in dropdown
            if (status.bdid != null) {
                me.pendingProjectId = status.bdid;
            }

            if (me.ddlProjects) {
                if (status.bdid) {
                    me._suspendProjectChange = true;
                    me.ddlProjects.setValue(status.bdid, true);
                    me._suspendProjectChange = false;
                } else {
                    me.ddlProjects.clear();
                }

                let selected = status.bdid ? me.ddlProjects.options[status.bdid] : null;
                me.myHtml.activityEdit.editArea.middleArea.infoBox.infoProject.html(selected ? selected.Name : "");
            }

            // set user in dropdown
            if (me.ddlUsers) {
                if (status.userId)
                    me.ddlUsers.setValue(status.userId, true);
                else
                    me.ddlUsers.clear();
            }

            if (typeof objActivityValidation !== "undefined") {
                objActivityValidation._validateUser(me);
                objActivityValidation._updateSaveButtonStatus(me, false);
            }

            // set description text
            if (typeof status.description === "string") {
                me.descriptionText = status.description;

                // update CLEditor text area
                if (me.areaDescription && me.areaDescription.$area) {
                    me.areaDescription.$area.val(status.description).blur().focus(); // set text and trigger update
                }

                // save last description for paste button
                if (status.description && status.description.length > 0) {
                    me.myStatus.shared = me.myStatus.shared || {};
                    me.myStatus.shared.lastDescription = status.description || "";
                }                
            }

            const descBox = me.myHtml.activityEdit.editArea.descBox;
            if (descBox && descBox.divDescription) {
                descBox.divDescription.html(status.description || "");
            }

            if (status.isPublic !== undefined) {
                me.myHtml.activityEdit.editArea.middleArea.statusBox.chbPublic.prop("checked", status.isPublic);
            }

            if (status.isDone !== undefined) {
                me.myHtml.activityEdit.editArea.middleArea.statusBox.chbDone.prop("checked", status.isDone);
            }

            if (status.cleared !== undefined) {
                me.myHtml.activityEdit.editArea.middleArea.statusBox.chbCleared.prop("checked", status.cleared);
            }

            if (typeof status.unread !== "undefined") {
                me.myHtml.activityEdit.editArea.middleArea.statusBox.chbUnread.prop("checked", !!status.unread);
            } else {
                me.myHtml.activityEdit.editArea.middleArea.statusBox.chbUnread.prop("checked", true);
            }

            if (status.km !== undefined) {
                me.myHtml.activityEdit.editArea.middleArea.statusBox.txtKm.val(objActivityEdit._toDE(status.km));
            }

            if (status.arrival !== undefined) {
                me.myHtml.activityEdit.editArea.middleArea.statusBox.txtTravelTime.val(objActivityEdit._toDE(status.arrival));
            }

            if (typeof objActivityValidation !== "undefined") {
                objActivityValidation._validate(me);
            }

            if (typeof objActivityValidation !== "undefined") {
                //objActivityEdit._clearSaveState(me);
                objActivityValidation._validateTicket(me);
                objActivityValidation._updateSaveButtonStatus(me, false);
            }

        } catch (e) {
            me._writeErr(e);
        }
    },


    _applyReadOnlyMode: function (me) {
        /// <summary>
        /// enables/disables the read only mode in the activity edit form
        /// </summary>
        try {
            if (!me.myHtml || !me.myHtml.activityEdit) return;

            const root = me.myHtml.activityEdit;
            const editArea = root.editArea || {};
            const info = editArea.middleArea ? editArea.middleArea.infoBox : null;
            const status = editArea.middleArea ? editArea.middleArea.statusBox : null;
            const menu = root.menu || {};

            const ticketBox = editArea.ticketBox || {};
            const descBox = editArea.descBox || {};

            const allFormItems = me.fnd("#div-activity-edit .formItem");

            let formItems = allFormItems;
            if (ticketBox.divProjects) {
                formItems = allFormItems.not(ticketBox.divProjects);
            }

            const inputs = me.fnd("#div-activity-edit input, #div-activity-edit textarea");
            const chbs = me.fnd("#div-activity-edit input[type=checkbox]");

            if (me.readOnlyMode) {
                me.dirty = false;

                formItems.addClass("readonly");                
                inputs.prop("readonly", true);
                chbs.prop("disabled", true);

                if (me.ddlProjects && typeof me.ddlProjects.disable === "function") {
                    me.ddlProjects.disable();
                }
                if (me.ddlUsers && typeof me.ddlUsers.disable === "function") {
                    me.ddlUsers.disable();
                }

                me.fnd("#chb-all-open-tickets, #chb-my-tickets, #chb-all-tickets, #chb-no-ticket")
                    .prop("disabled", true);
                if (editArea.ticketBox && editArea.ticketBox.divTicketList) {
                    editArea.ticketBox.divTicketList.addClass("disabled"); 
                }

                if (status) {
                    status.chbPublic.prop("disabled", true);
                    status.chbDone.prop("disabled", true);
                    status.chbCleared.prop("disabled", true);
                    status.chbUnread.prop("disabled", true);
                }

                if (menu.btnSave && typeof menu.btnSave.button === "function") {
                    menu.btnSave.button("disable");
                }
                if (menu.btnPasteLast && typeof menu.btnPasteLast.button === "function") {
                    menu.btnPasteLast.button("disable");
                }

                // readonly text
                me.fnd(".cleditorMain").hide();
                if (descBox && descBox.divDescription) {
                    const currentHtml = me.descriptionText || (descBox.txtDescription && descBox.txtDescription.val()) || "";
                    descBox.divDescription.html(currentHtml).show();
                }

            } else {
                formItems.removeClass("readonly");
                inputs.not(".readonly").prop("readonly", false);
                chbs.prop("disabled", false);

                if (me.ddlProjects && typeof me.ddlProjects.enable === "function") {
                    me.ddlProjects.enable();
                }
                if (me.ddlUsers && typeof me.ddlUsers.enable === "function") {
                    me.ddlUsers.enable();
                }

                if (editArea.ticketBox && editArea.ticketBox.divTicketList) {
                    editArea.ticketBox.divTicketList.removeClass("disabled");
                }

                if (menu.btnPasteLast && typeof menu.btnPasteLast.button === "function") {
                    objActivityEdit._updatePasteButtonState(me);
                }

                me.fnd(".cleditorMain").show();

                if (descBox && descBox.divDescription) {
                    descBox.divDescription.hide();
                }
            }
        } catch (e) {
            me._writeErr(e);
        }
    },

    _updateNavButtons: function (me) {
        /// <summary>
        /// This function updates the navigation buttons (previous/next) based on the current edit index and available rows
        /// </summary>
        try {
            var src = me.myStatus.editSource;
            var rows = (src === "list") ? (me.myStatus.allActivities.rows || []) : (src === "dayview") ? (me.myStatus.allDailyActivities.rows || []) : [];

            var idx = me.myStatus.editIndex;
            var m = me.myHtml.activityEdit.menu;

            var hasPrev = Array.isArray(rows) && typeof idx === "number" && idx > 0;
            var hasNext = Array.isArray(rows) && typeof idx === "number" && rows.length && (idx < rows.length - 1);

            if (!me.myStatus.editMode) { hasPrev = false; hasNext = false; }

            m.btnPrev.button(hasPrev ? "enable" : "disable");
            m.btnNext.button(hasNext ? "enable" : "disable");
        } catch (e) { me._writeErr(e); }
    },

    _navigateThroughEntries: function (me, step) {
        /// <summary>
        /// This function navigates through the entries in the edit view based on the step (-1 for previous, +1 for next)
        /// </summary>

        try {
            var src = me.myStatus.editSource;
            var rows = (src === "list") ? (me.myStatus.allActivities.rows || []) : (src === "dayview") ? (me.myStatus.allDailyActivities.rows || []) : [];

            var idx = me.myStatus.editIndex;
            if (!Array.isArray(rows) || !rows.length || typeof idx !== "number") return;

            var next = idx + step;
            if (next < 0 || next >= rows.length) return;

            me.myStatus.editIndex = next;
            var entry = rows[next];

            me.myStatus.editMode = true;
            me.myStatus.editAId = entry.id;

            me.editReqId = (me.editReqId || 0) + 1;  // request id, that we sent only a request (also for double clicks or fast switching)
            const reqId = me.editReqId;

            objActivityEdit._editExistingActivity(me, entry, reqId);
            objActivityEdit._updateNavButtons(me);
        } catch (e) { me._writeErr(e); }
    },

    _disableNav: function (me) {
        /// <summary>
        /// This function disables the navigation buttons (previous/next)
        /// </summary>

        try {
            var m = me.myHtml.activityEdit.menu;
            m.btnPrev.button("disable");
            m.btnNext.button("disable");
        } catch (e) { me._writeErr(e); }
    },

    _toDE: function (v) {
        if (v === null || v === undefined || v === "") return "";
        var n = Number(String(v).replace(',', '.'));
        if (isNaN(n)) return "";
        return new Intl.NumberFormat('de-DE', { useGrouping: false, maximumFractionDigits: 3 }).format(n);
    },

    _getCurrentFullSelection: function (me) {
        const info = me.myHtml.activityEdit.editArea.middleArea;
        const dateObj = info.infoBox.dateBoxSingle.vcDate("getDate"); // {from,to}
        const date = dateObj && dateObj.to;

        const startTime = info.infoBox.txtStartTime.val();
        const endTime = info.infoBox.txtEndTime.val();

        const ticketId = me.selectedTicketId || -1;
        const bdid = me.ddlProjects ? me.ddlProjects.getValue() : -1;
        const userId = me.ddlUsers ? me.ddlUsers.getValue() : me.flags.UserId;

        const isPublic = info.statusBox.chbPublic.is(":checked");
        const isDone = info.statusBox.chbDone.is(":checked");
        const cleared = info.statusBox.chbCleared.is(":checked");

        const parseDE = s => {
            let t = String(s || "").trim().replace(/\./g, "").replace(',', '.');
            const n = Number(t); return isNaN(n) ? null : n;
        };
        const km = parseDE(info.statusBox.txtKm.val());
        const arrival = parseDE(info.statusBox.txtTravelTime.val());

        const description = me.descriptionText || "";

        return {
            date: date,
            starttime: startTime,
            endtime: endTime,
            atid: ticketId,
            bdid: bdid,
            uid: userId,
            description: description,
            isPublic: isPublic,
            done: isDone,
            cleared: cleared,
            km: km,
            arrival: arrival
        };
    },

    _updateActiveRow: function (me, patch) {
        try {
            const src = me.myStatus.editSource;
            const rows = (src === "list") ? (me.myStatus.allActivities.rows || []) : (src === "dayview") ? (me.myStatus.allDailyActivities.rows || []) : [];
            const idx = me.myStatus.editIndex;
            if (!Array.isArray(rows) || typeof idx !== "number" || !rows[idx]) return;

            Object.assign(rows[idx], patch);
        } catch (e) { me._writeErr(e); }
    },

    _saveActivity: function (me) {
        /// <summary>
        /// This function saves the current activity by collecting all parameters and sending them to the server
        /// </summary>
        try {      
            if (me.readOnlyMode) { return false; }
           
            let dateObj = me.myHtml.activityEdit.editArea.middleArea.infoBox.dateBoxSingle.vcDate("getDate");
            let date = dateObj && dateObj.to ? dateObj.to : new Date();

            let startTime = me.myHtml.activityEdit.editArea.middleArea.infoBox.txtStartTime.val();
            let endTime = me.myHtml.activityEdit.editArea.middleArea.infoBox.txtEndTime.val();
            let ticketId = me.selectedTicketId || -1;
            let bdid = me.ddlProjects ? me.ddlProjects.getValue() : -1;
            let userId = me.ddlUsers ? me.ddlUsers.getValue() : me.flags.UserId;
            let isPublic = me.myHtml.activityEdit.editArea.middleArea.statusBox.chbPublic.is(":checked");
            let isDone = me.myHtml.activityEdit.editArea.middleArea.statusBox.chbDone.is(":checked");
            let cleared = me.myHtml.activityEdit.editArea.middleArea.statusBox.chbCleared.is(":checked");

            const parseDE = function (s) {
                var t = String(s || "").trim();
                t = t.replace(/\./g, "").replace(',', '.');
                var n = Number(t);
                return (isNaN(n) ? null : n);
            };
            let km = parseDE(me.myHtml.activityEdit.editArea.middleArea.statusBox.txtKm.val());
            let arrival = parseDE(me.myHtml.activityEdit.editArea.middleArea.statusBox.txtTravelTime.val());

            let description = me.descriptionText || "";
            var changeType = me.myStatus.editMode ? 2 : 1;
            var markUnread = !!me.myHtml.activityEdit.editArea.middleArea.statusBox.chbUnread.is(":checked");

            // parameter list 
            let param = {
                Id: me.myStatus.editAId,
                changeTypeId: changeType,      // 1 = Add new activity, 2 = Edit existing activity
                Date: date,
                StartTime: startTime,
                EndTime: endTime,
                Description: description,
                UserId: userId,
                ProjectId: -1,
                BdId: bdid,      // project id
                TicketId: ticketId,
                IsPublic: isPublic,
                Done: isDone,
                Cleared: cleared,
                Km: km,
                MarkUnread: markUnread,
                Arrival: arrival,
                Blid: me.flags.Blid|| -1,
                Charge: true                   // Default                
            };

            // update db
            me.updateData(param, function (result) {
                var ok = !!(result && result.Success === true);

                if (ok) {
                    objActivityEdit._showSaveOk(me);

                    me.myStatus.shared = me.myStatus.shared || {};
                    const lastSel = objActivityEdit._getCurrentFullSelection(me);
                    me.myStatus.shared.lastActivity = lastSel;
                    me.myStatus.shared.lastDescription = lastSel.description || "";

                    // if new activity was created, set the new activity ID in the status and edit mode to true
                    if (!me.myStatus.editMode) {
                        me.myStatus.editAId = result.ActivityId; // set new activity ID after creating a new activity
                        me.myStatus.editMode = true;

                        objActivityEdit._updatePasteButtonState(me);
                    }
                    
                } else {
                    // we show an error message if the save operation was not successful
                    let errorMsg = (result && result.Message) ? result.Message : "Daten konnten vom Server nicht verarbeitet werden.";
                    objActivityEdit._setStateError(me, "* " + errorMsg);
                }
            });


        } catch (e) { me._writeErr(e); }
    },

    _calcEditorHeight: function (me) {
        var hArea = me.fnd("#div-middle-area").height();
        var hInfo = me.fnd("#div-col-info").outerHeight();
        var hDesc = hArea - hInfo - 10; // 10px padding
        var hEditor = hDesc - 15 - 7; // 15px caption and 5px padding
        me.fnd("#div-col-description").css({ outerHeight: hDesc + "px" });
        return hEditor;
    },

    _initTextEditor: function (me, bEdit) {
        /// <summary>
        /// This function initializes the CLEditor for the description text area
        /// </summary>
        var h, w;

        try {
            if (me.error) return false;           

            // default text
            me.descriptionText = typeof (me.descriptionText) !== "undefined" ? me.entry.Data.Description || "" : "";

            w = parseInt(me.fnd("#div-editor").width()) - 25;
            h = objActivityEdit._calcEditorHeight(me);

            // initialize CLEditor
            me.areaDescription = me.myHtml.activityEdit.editArea.descBox.txtDescription.cleditor({
                height: h,
                width: w,
                updateTextArea: function (html) {

                    // Outlook/MSO 
                    if (html.indexOf("mso-ansi-language") > -1 || html.indexOf("<o:") > -1 || html.indexOf("<w:") > -1) {
                        // we open the cleanup dialog
                        me.myHtml.activityEdit.editArea.descBox.txtDescription.val(me.descriptionText).blur().focus();
                        if (typeof me.openHtmlCleanupDialog === "function") {
                            me.openHtmlCleanupDialog();
                        }
                        return true;
                    }

                    let cleanedHtml = html.replace(/\n/g, "<br />"); 
                    me.descriptionText = cleanedHtml;

                    me.myHtml.activityEdit.editArea.descBox.txtDescription.val(cleanedHtml).blur();

                    me.dirty = true;
                    if (typeof objActivityValidation !== "undefined") {
                        objActivityEdit._clearSaveState(me);
                        objActivityValidation._validateDescription(me);
                        objActivityValidation._updateSaveButtonStatus(me, false);
                    }
                },
                controls: 'bold italic underline | removeformat | bullets numbering '
            })[0];

            me.areaDescription.refresh();

            // show/hide the CLEditor main area based on the edit mode
            if (bEdit) {
                me.fnd(".cleditorMain").show();
            } else {
                me.fnd(".cleditorMain").hide();
            }

            const descBox = me.myHtml.activityEdit.editArea.descBox;
            if (bEdit && descBox && descBox.divDescription) {
                descBox.divDescription.hide();
            }

            return true;
        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },    

    _resetEditForm: function (me) {
        /// <summary>
        /// This function resets the activity edit form to its default state
        /// </summary>
        try {
            me.dirty = false;
            me.readOnlyMode = false;
            objActivityEdit._applyReadOnlyMode(me);

            let infoBox = me.myHtml.activityEdit.editArea.middleArea.infoBox;

            // reset time info
            infoBox.txtStartTime.val("");
            infoBox.txtEndTime.val("");

            // reset ticket info
            infoBox.txtTickets.html("");
            infoBox.infoProject.html("");

            // reset project info
            let projectBox = me.myHtml.activityEdit.editArea.ticketBox;

            if (me.ddlProjects) {
                me.ddlProjects.clear();
            }
            projectBox.txtProjects.val("");

            // reset ticket selection
            me.fnd("#chb-all-open-tickets, #chb-my-tickets, #chb-all-tickets, #chb-no-ticket").prop("checked", false);
            me.myStatus.filterId = undefined;
            me.selectedTicketId = null;
            me.myHtml.activityEdit.editArea.middleArea.statusBox.chbUnread.prop("checked", true);

            // reset user info
            if (me.ddlUsers) {
                me.ddlUsers.clear();
            }
            infoBox.txtUsers.val("");

            // set current date in date box
            let today = new Date();
            let formatted = objActivityEdit._formatDate(today);

            // initialize date box with today's date
            infoBox.dateBoxSingle.vcDate("destroy");
            infoBox.dateBoxSingle.vcDate({
                mode: "Single",
                align: "right",
                interval: 1,
                langID: me.settings.userLangIDForCulture || me.specific.userLangID,
                defaultDate: formatted,
                callback: function (obj) {
                    me.myStatus.selectedDate = obj.singleDate;
                }
            });

            

        } catch (e) {
            me._writeErr(e);
        }
    },

    _renderTicketList: function (me, ticketData) {
        /// <summary>
        /// This function renders the ticket list in the activity edit view based on the provided ticket data
        /// </summary>
        try {

            const listWrapper = me.myHtml.activityEdit.editArea.ticketBox.divTicketList;
            let dataArea = listWrapper.children(".lst-entries.vc-list-table");
            if (!dataArea.length) {
                dataArea = $("<div>", { "class": "lst-entries vc-list-table" }).appendTo(listWrapper);
            }
            dataArea.empty();

            listWrapper.removeClass("disabled");

            if (!ticketData || !ticketData.rows || ticketData.rows.length === 0) {
                const emptyItem = $("<div>", { "class": "vc-list-item empty" });
                const col = $("<div>", { "class": "vc-list-col col0" }).css("width", "100%");
                const el = $("<div>", { "class": "vc-list-col-element" }).text(me.specific.resources.noEntriesExist);
                col.append(el); emptyItem.append(col);
                dataArea.append(emptyItem);

                // reset previous ticket selection
                me.selectedTicketId = null;
                me.myHtml.activityEdit.editArea.middleArea.infoBox.txtTickets.html("");
                dataArea.find(".vc-list-item").removeClass("selected");

                // disable ticket list
                listWrapper.addClass("disabled");

                listWrapper.show();
                return;
            }

            ticketData.rows.forEach(row => {
                const item = $("<div>", { "class": "vc-list-item", "role": "button" }).data("ticket-id", row.id).css({ cursor: "pointer" });
                const col = $("<div>", { "class": "vc-list-col col0" }).css("width", "100%");
                const el = $("<div>", { "class": "vc-list-col-element ticket-cell" });
                const fullName = row.name || "";

                let html;
                const sepIndex = fullName.indexOf(" - ");

                // get T+No from full name for link on Ticket
                if (sepIndex > 1 && fullName.charAt(0) === "T") {
                    const ticketPart = fullName.substring(0, sepIndex);
                    const rest = fullName.substring(sepIndex);
                    html = `<span class="ticket-link" title="${me.specific.resources.openTicket || ""}">${ticketPart}</span>${rest}`;
                } else {
                    html = fullName; // if split is not possible, show full name without link
                }

                el.html(html);
                col.append(el);
                item.append(col);

                item.on("click", function (e) {
                    if ($(e.target).closest(".ticket-link").length) {
                        if (typeof me._openTicketFromActivity === "function") {
                            const blid = row.blid || me.flags.Blid || -1;
                            me._openTicketFromActivity(row.id, blid);
                        }
                        e.stopPropagation();
                        return;
                    }

                    me.selectedTicketId = row.id;
                    me.myHtml.activityEdit.editArea.middleArea.infoBox.txtTickets.html(fullName);

                    if (typeof objActivityValidation !== "undefined") {
                        me.dirty = true;
                        objActivityEdit._clearSaveState(me);
                        objActivityValidation._validateTicket(me);
                        objActivityValidation._updateSaveButtonStatus(me, false);
                    }

                    dataArea.find(".vc-list-item").removeClass("selected");
                    $(this).addClass("selected");
                });


                dataArea.append(item);
            });

            listWrapper.show();
            dataArea.children(".vc-list-item").removeClass("alt").filter(":odd").addClass("alt");
        } catch (e) {
            me._writeErr(e);
        }
    },



    _getTicketDllList: function (me, edit, bdid, callback) {
        /// <summary>
        /// This function retrieves the ticket list for the dropdown in the activity edit view.
        /// </summary>
        try {
            var pid = (bdid === "" || bdid == null) ? -1 : parseInt(bdid, 10);
            if (isNaN(pid)) pid = -1;

            var fid = (typeof me.myStatus.filterId === "number") ? me.myStatus.filterId : -1;

            // if no ticket is selected, we use 0 (all open) for the request
            var displayFid = (fid === -1) ? 0 : fid;  
            var keepDisabled = (fid === -1);

            me._ticketsReqId = (me._ticketsReqId || 0) + 1;
            const reqId = me._ticketsReqId;

            me.getData({ SelectedMode: "tickets", Edit: edit, SelectedBdid: pid, TFilterId: displayFid }, function (result) {
                if (reqId !== me._ticketsReqId) return;

                var safe = (result && Array.isArray(result.rows)) ? result : { rows: [] };

                me._lastTicketResult = safe;
                objActivityEdit._renderTicketList(me, safe);

                // if "no ticket" is selected, we keep the ticket list disabled
                if (keepDisabled) {
                    me.myHtml.activityEdit.editArea.ticketBox.divTicketList.addClass("disabled");
                }

                if (typeof callback === "function") callback();

                if (typeof objActivityValidation !== "undefined") {
                    objActivityEdit._clearSaveState(me);
                    objActivityValidation._validateTicket(me);
                    objActivityValidation._updateSaveButtonStatus(me, false);
                }
            });

        } catch (e) { me._writeErr(e); }
    },

    _getTicketDllListCached: function (me, edit, bdid, callback) {
        /// <summary>
        /// This function retrieves the ticket list for the dropdown in the activity edit view, using a cache to avoid redundant requests.
        /// </summary>
        try {
            let pid = -1;
            if (bdid !== null && bdid !== "") {
                const parsed = parseInt(bdid, 10);
                pid = Number.isNaN(parsed) ? -1 : parsed;
            }
            const fid = (typeof me.myStatus.filterId === "number") ? me.myStatus.filterId : -1;

            const displayFid = (fid === -1) ? 0 : fid; // if "no ticket" is selected, use 0 (all open) for caching
            const keepDisabled = (fid === -1);

            const key = displayFid + ":" + pid;

            if (me._cache.tickets.has(key)) {
                objActivityEdit._renderTicketList(me, me._cache.tickets.get(key));
                if (keepDisabled) {
                    me.myHtml.activityEdit.editArea.ticketBox.divTicketList.addClass("disabled");
                }
                if (typeof callback === "function") callback();
                return;
            }

            objActivityEdit._getTicketDllList(me, edit, pid, function () {
                if (me._lastTicketResult) {
                    me._cache.tickets.set(key, me._lastTicketResult);
                }
                if (keepDisabled) {
                    me.myHtml.activityEdit.editArea.ticketBox.divTicketList.addClass("disabled");
                }
                if (typeof callback === "function") callback();
            });
        } catch (e) { me._writeErr(e); }
    },

    _getProjectDllList: function (me, edit) {
        /// <summary>
        /// This function retrieves the project list for the dropdown in the activity edit view.
        /// </summary>
        try {
            me.getData({ SelectedMode: "projects", Edit: edit }, function (result) {
                if (!result || !result.rows) return;

                let ddl = me.myHtml.activityEdit.editArea.ticketBox.ddlProjects;
                let txt = me.myHtml.activityEdit.editArea.ticketBox.txtProjects;

                me.ddlProjects = objActivityEdit._initSelectizeInDll(me, ddl, result, txt, true);

                if (me.pendingProjectId != null) {
                    const id = me.pendingProjectId;
                    me._suspendProjectChange = true;
                    me.ddlProjects.setValue(id, true);
                    me._suspendProjectChange = false;

                    const sel = me.ddlProjects.options[id];
                    me.myHtml.activityEdit.editArea.middleArea.infoBox.infoProject.html(sel ? sel.Name : "");
                    me.pendingProjectId = null;
                }
            });
        } catch (e) {
            me._writeErr(e);
        }
    },

    _getUserDllList: function (me) {
        /// <summary>
        /// This function retrieves the user list for the dropdown in the activity edit view.
        /// </summary>
        try {
            me.getData({ SelectedMode: "users" }, function (result) {
                if (!result || !result.rows) return;

                let ddl = me.myHtml.activityEdit.editArea.middleArea.infoBox.ddlUsers;
                let txt = me.myHtml.activityEdit.editArea.middleArea.infoBox.txtUsers;

                me.ddlUsers = objActivityEdit._initSelectizeInDll(me, ddl, result, txt, true);

                if (typeof objActivityValidation !== "undefined") {
                    objActivityValidation._validateUser(me);
                    objActivityValidation._updateSaveButtonStatus(me, false);
                }
            });
        } catch (e) {
            me._writeErr(e);
        }
    },


    _updatePasteButtonState: function (me) {
        try {
            if (!me.myHtml.activityEdit.menu) return;

            const menu = me.myHtml.activityEdit.menu;
            const btn = menu.btnPasteLast;
            if (!btn || !btn.length) return;

            const hasLast = me.myStatus && me.myStatus.shared && me.myStatus.shared.lastActivity;

            if (hasLast) {
                btn.button("enable");
            } else {
                btn.button("disable");
            }
        } catch (e) {
            me._writeErr(e);
        }
    },


    _validateTime: function (timeStr) {
        // check if the time string is in HH:MM format
        var timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
        return timeRegex.test(timeStr);
    },

    _validateFields: function (me) {
        /// <summary>
        /// This function validates the start and end time fields in the activity edit view.
        /// </summary>

        var bError = false;
        var text = "";

        var startTime = me.myHtml.activityEdit.editArea.middleArea.infoBox.txtStartTime.val();
        if (startTime.length > 0 && !this._validateTime(startTime)) {
            me.myHtml.activityEdit.editArea.middleArea.infoBox.txtStartTime.addClass("error");
            bError = true;
        } else {
            me.myHtml.activityEdit.editArea.middleArea.infoBox.txtStartTime.removeClass("error");
        }

        var endTime = me.myHtml.activityEdit.editArea.middleArea.infoBox.txtEndTime.val();
        if (endTime.length > 0 && !this._validateTime(endTime)) {
            me.myHtml.activityEdit.editArea.middleArea.infoBox.txtEndTime.addClass("error");
            bError = true;
        } else {
            me.myHtml.activityEdit.editArea.middleArea.infoBox.txtEndTime.removeClass("error");
        }

        return !bError;
    },

    _formatDate: function (dateInput) {
        /// <summary>
        /// This function formats a date input (Date object, string, or number) into a German date format
        /// </summary>

        let dateObj;

        try {
            if (dateInput instanceof Date) {
                dateObj = dateInput;
            } else if (typeof dateInput === "string") {
                let germanDateRegex = /^(\d{2})\.(\d{2})\.(\d{4})$/;
                let match = dateInput.match(germanDateRegex);

                if (match) {
                    let day = parseInt(match[1], 10);
                    let month = parseInt(match[2], 10) - 1;
                    let year = parseInt(match[3], 10);
                    dateObj = new Date(year, month, day);
                } else {
                    dateObj = new Date(dateInput);
                }

            } else if (typeof dateInput === "number") {
                dateObj = new Date(dateInput);
            } else {
                return false;
            }

            if (isNaN(dateObj.getTime())) {
                return false;
            }

            return new Intl.DateTimeFormat('de-DE', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            }).format(dateObj);

        } catch (e) {
            return false; 
        }
    },

    _setNeutral: function (wrap) {
        if (!wrap || !wrap.length) return;
        wrap.removeClass("formItemInvalid formItemValid");
        wrap.find(".validation-icon").empty().attr("title", "");
    },

    _finalizeTime: function (me, inp, wrapSel) {
        const v = String(inp.val() || "").trim();
        if (v === "") {
            objActivityEdit._clearSaveState(me);
            objActivityValidation._validateTimeTextbox(me, wrapSel, inp); 
            objActivityValidation._updateSaveButtonStatus(me, false);
            return;
        }
        const norm = objActivityValidation._normalizeTimeSmart(v);
        if (norm) inp.val(norm);

        objActivityEdit._clearSaveState(me);
        objActivityValidation._validateTimeTextbox(me, wrapSel, inp);
        objActivityValidation._validateTimeRelation(me);
        objActivityValidation._updateSaveButtonStatus(me, false);
    },

}; 